import { Controller } from "@hotwired/stimulus"

// Intercepts paste events containing HTML <table> elements to work around a Lexical
// bug where WrappedTableNode conflicts with TableNode during HTML import.
// Only handles HTML paste with tables. Never touches plain text/markdown paste.
export default class extends Controller {
  connect() {
    document.addEventListener("paste", this.handlePaste, true)
  }

  disconnect() {
    document.removeEventListener("paste", this.handlePaste, true)
  }

  handlePaste = (event) => {
    const editor = event.target.closest("lexxy-editor")
    if (!editor?.contents) return

    const html = event.clipboardData?.getData("text/html") || ""
    if (!html.includes("<table")) return

    const parser = new DOMParser()
    const doc = parser.parseFromString(html, "text/html")
    const table = doc.querySelector("table")
    if (!table) return

    event.preventDefault()
    event.stopImmediatePropagation()

    editor.contents.insertHtml(this.tableToSafeHtml(table))
  }

  tableToSafeHtml(table) {
    const rows = []
    for (const row of table.rows) {
      const cells = []
      for (const cell of row.cells) {
        const text = cell.textContent.trim()
        if (text) cells.push(text)
      }
      if (cells.length > 0) rows.push(cells.join(" | "))
    }
    if (rows.length === 0) return ""

    const parts = [`<p><strong>${this.esc(rows[0])}</strong></p>`]
    for (let i = 1; i < rows.length; i++) {
      parts.push(`<p>${this.esc(rows[i])}</p>`)
    }
    return parts.join("")
  }

  esc(text) {
    const div = document.createElement("div")
    div.textContent = text
    return div.innerHTML
  }
}
